module.exports = __webpack_public_path__ + "img/logo.bbebf9c3.svg";